import Typography from "src/blitz/Typography"
import styles from "./Tooltip.module.scss"
import Shape from "./Shape/Shape"
import { MEAN_OF_ALL, NAME } from "src/components/shared/Charts/constant"
import translate, { TranslateComponent } from "src/common/translations"


const Tooltip = (props) => {
  const {
    visibility = "",
    title1 = "",
    positionObj = {},
    dimensionsObj = {},
    data = [],
  } = props
  if (!data?.length) {
    return null
  }

  const getTranslatedValue = (equipmentPropertyName) => {
    return `${equipmentPropertyName[0] ? equipmentPropertyName[0] : ""}${(equipmentPropertyName.length >= 2 && equipmentPropertyName[0]) ? ": " : ""}${equipmentPropertyName[1] ? translate(equipmentPropertyName[1]) : ""}`
  }

  const meanObj = data?.filter((obj) => obj?.name === MEAN_OF_ALL)
  const lengendsObj = data?.filter((obj) => obj?.name !== MEAN_OF_ALL)

  const tooltipData = [...meanObj, ...lengendsObj]
  return (
    <div
      style={{
        visibility: visibility,
        position: "absolute",
        ...positionObj,
        ...dimensionsObj,
        zIndex: "1000"
      }}
      data-testid="tooltip-timeseries-multiple-wrapper"
      className={styles.tooltipWrapper}
    >
      <div className={styles.titleWrapper} data-testid="ttmw-title-wrapper">
        <Typography
          tagType="span"
          styleType="p4"
          fontType="boldFont"
          data-testid="ttmw-title-1"
        >{`${title1}`}</Typography>
      </div>
      {tooltipData?.map((obj, i) => {
        const equipmentPropertyName = obj?.name.split("#$")
        const isNumeric = (str) => /^[+-]?\d+(\.\d+)?$/.test(str)
        const translateObjectValue=<TranslateComponent>{ obj?.value}</TranslateComponent>
        return (
          <div
            key={i}
            className={styles?.legendWrapper}
            data-testid={`ttmw-legend-wrapper-${i}`}
          >
            <div className={styles?.lwLeft}>
              <Shape color={obj?.color} shape={obj?.shape} dataTestid={`ttmw-legend-shape-${i}`} />
              <Typography
                tagType="custom"
                fontType={obj?.isNearestPoint ? "boldFont" : ""}
                styleType="p4"
                testId={`ttmw-legend-shape-${i}`}
                customFunction={getTranslatedValue}
              >{equipmentPropertyName}</Typography>
            </div>
            <div className={styles?.lwRight}>
              <Typography
                tagType="span"
                fontType={obj?.isNearestPoint ? "boldFont" : ""}
                styleType="p4"
                testId={`ttmw-legend-value-symbol-${i}`}
              > 
               <>{isNumeric(obj?.value) ? obj?.value : translateObjectValue} {obj?.symbol}</>
               </Typography>
            </div>
          </div>
        )
      })}
    </div>
  )
}

export default Tooltip
